export function stringToColor(str: string): string {
	let hash = 0;

	for (let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = '#';
	for (let i = 0; i < 3; i++) {
		const value = (hash >> (i * 8)) & 0xff;
		const str = `00${value.toString(16)}`;
		color += str.substring(str.length - 2, str.length);
	}

	return color;
}
